export default "__VITE_ASSET__a5b280fb__"